export const SetCurrentUser = (user) => {
	return async dispatch => {
		await dispatch({
			type: 'SET_USER',
			payload: user
		});
	}
}

export const SetUserPreferences = (preferences) => {
	return async dispatch => {
		await dispatch({
			type: 'SET_PREFERENCES',
			payload: preferences
		});
	}
}